import { apiClientFactory } from '@/client/api-client.factory';
import { parseEnviourmentUrl } from '@/utils/helpers/env.helper';
import * as Sentry from '@sentry/react';

export * from './api-client.factory';
export * from './auth';
export * from './axios-client.factory';

const apiUrl = parseEnviourmentUrl().apiUrl;

let unauthorizedRedirectScheduled = false;

export const client = apiClientFactory({
  apiUrl,
  onUnauthorized: (url?: string, status?: number) => {
    if (status === 401 && !unauthorizedRedirectScheduled) {
      unauthorizedRedirectScheduled = true;

      Sentry.captureMessage('Unauthorized API request', {
        level: 'warning',
        tags: { endpoint: url },
      });

      setTimeout(() => {
        window.location.href = '/logout';
      }, 100);
    }
  },
});
